import axios from 'axios'

// Relative path so the Vite dev proxy (dev) and nginx (production)
// both forward /api requests to the Flask backend on port 5000.
const API_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default api
